import React from 'react';

export type RegistrationParams = {
  partner?: string;
  plan_id?: string;
  redirect_uri?: string;
  state?: string;
  // One-way Ring account linking: Ring redirects to /ring/link?nonce=&time= .
  nonce?: string;
  time?: string;
};

const STORAGE_KEY = 'registration_params';

export function useRegistrationParams() {
  const saveParams = React.useCallback((params: RegistrationParams) => {
    // Only save if at least one param exists
    if (
      params.partner ||
      params.plan_id ||
      params.redirect_uri ||
      params.state ||
      params.nonce ||
      params.time
    ) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params));
    }
  }, []);

  const getParams = React.useCallback((): RegistrationParams | null => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  }, []);

  const clearParams = React.useCallback(() => {
    sessionStorage.removeItem(STORAGE_KEY);
  }, []);

  return { saveParams, getParams, clearParams };
}
